module.exports = __webpack_public_path__ + "img/yolo13_show.1bac6449.png";